// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  background: #141323;
  color: white;
  height: 100vh;
  align-items: center;
}

.login-logo {
  text-align: center;
  margin-bottom: 24px;
}

.login-logo h1, h3 {
  color: white;
  font-weight: 100;
  line-height: 1em;
}

.login-logo img {
  max-width: 80px;
  margin-bottom: 2em;
}

.login-form {
  max-width: 690px;
  margin: 0 auto;
}
.login-form-forgot {
  float: right;
}
.login-form-button {
  width: 100%;
}

.login-form .ant-checkbox-wrapper {
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/Login/LoginForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd","sourcesContent":[".login-container {\n  display: flex;\n  background: #141323;\n  color: white;\n  height: 100vh;\n  align-items: center;\n}\n\n.login-logo {\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.login-logo h1, h3 {\n  color: white;\n  font-weight: 100;\n  line-height: 1em;\n}\n\n.login-logo img {\n  max-width: 80px;\n  margin-bottom: 2em;\n}\n\n.login-form {\n  max-width: 690px;\n  margin: 0 auto;\n}\n.login-form-forgot {\n  float: right;\n}\n.login-form-button {\n  width: 100%;\n}\n\n.login-form .ant-checkbox-wrapper {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
